export class ApiError extends Error {
    constructor(message, status, body) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.body = body;
    }
}

const buildHeaders = (authToken, { json = false, headers = {} } = {}) => {
    const result = {
        Accept: 'application/json',
        ...headers,
    };

    if (authToken) {
        result.Authorization = `Bearer ${authToken}`;
    }

    if (json) {
        result['Content-Type'] = headers['Content-Type'] || 'application/json';
    }

    return result;
};

const parseBody = async (response) => {
    if (response.status === 204) {
        return null;
    }

    const text = await response.text();
    if (!text) {
        return null;
    }

    try {
        return JSON.parse(text);
    } catch {
        return text;
    }
};

export const apiRequest = async (url, {
    method = 'GET',
    authToken,
    body,
    json = body !== undefined,
    headers,
    parseJson = true,
} = {}) => {
    const response = await fetch(url, {
        method,
        headers: buildHeaders(authToken, { json, headers }),
        body: body !== undefined && json && typeof body !== 'string'
            ? JSON.stringify(body)
            : body,
    });

    if (!response.ok) {
        const errorBody = await parseBody(response);
        throw new ApiError(
            `Request failed: ${method} ${url} (${response.status})`,
            response.status,
            errorBody
        );
    }

    if (!parseJson) {
        return response;
    }

    return parseBody(response);
};

export const apiGet = (url, options = {}) =>
    apiRequest(url, { ...options, method: 'GET', json: false });

export const apiPost = (url, body, options = {}) =>
    apiRequest(url, { ...options, method: 'POST', body });

export const apiPut = (url, body, options = {}) =>
    apiRequest(url, { ...options, method: 'PUT', body });

export const apiDelete = (url, options = {}) =>
    apiRequest(url, { ...options, method: 'DELETE' });
